module.exports = __webpack_public_path__ + "static/img/02_03_boost.4a7474f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_03_boost.png
// module id = JiD7
// module chunks = 12